import React, { Fragment, useState, useEffect } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Collapse } from 'reactstrap';
import CustomControl from '../CustomControl/CustomControl';
import Hint from '../Hint/Hint';
import NewsShowcaseSettings from './NewsShowcaseSettings';

const NewsShowcase = ({ featuresList, changeFeature, disabled, changeShowcaseSettings }) => {
  const [isSettingsVisible, showSettings] = useState(false);

  const toggleSettings = e => {
    e.preventDefault();
    showSettings(!isSettingsVisible);
  };

  useEffect(() => {
    if (featuresList['3'] || featuresList['4']) {
      showSettings(true);
    }
  }, []);

  return (
    <Fragment>
      <CustomControl
        key={`rt_market_enable`}
        id={`1`}
        name={`1`}
        checked={featuresList['1'] && !disabled}
        disabled={disabled}
        value={1}
        onChange={changeFeature}
        type="checkbox"
        className="custom-control-xs"
      >
        <FormattedMessage
          id={'flow.features.news_showcase.label'}
          defaultMessage={'Enable news showcase'}
        />
      </CustomControl>

      <FormattedMessage
        id={'flow.features.news_showcase.title'}
        defaultMessage={'News Showcase - a tool to increase conversion'}
      >
        {title => (
          <Hint title={title} id={`news_showcase_hint`} placement="right">
            <FormattedHTMLMessage
              tagName="div"
              id={'flow.features.news_showcase.desc'}
              defaultMessage={
                '<p>When you go from the&nbsp;prelander to the&nbsp;landing page, the prelander reloads to the&nbsp;news site. After viewing the landing page, the user remains on the&nbsp;news site which is filled with teasers of top offers. </p> <p> When placing an order, the conversion will appear in the&nbsp;statistics even if the offer is not&nbsp;connected. </ p> There are 7&nbsp;news topics on&nbsp;a choice based on the&nbsp;target group of the stream being created.'
              }
            />
          </Hint>
        )}
      </FormattedMessage>
      {featuresList['1'] && (
        <div className="news-showcase-settings">
          <a href="#" className="pseudo-link" onClick={toggleSettings}>
            {isSettingsVisible ? (
              <FormattedMessage
                id="flow.features.news_showcase.settings.hide"
                defaultMessage="Hide showcase Settings"
              />
            ) : (
              <FormattedMessage
                id="flow.features.news_showcase.settings.show"
                defaultMessage="Show showcase Settings"
              />
            )}
          </a>
          <Collapse isOpen={isSettingsVisible}>
            <NewsShowcaseSettings change={changeShowcaseSettings} featuresList={featuresList}/>
          </Collapse>
        </div>
      )}
    </Fragment>
  );
};

export default NewsShowcase;
